import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import * as pdfjs from 'pdfjs-dist';
import { PDF_WORKER_SRC } from '@iupics-util/tools/pdf-worker.util';
@Component({
  selector: 'iu-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss'],
  standalone: true,
})
export default class PdfViewerComponent implements OnInit {
  @Input() dataUrl;
  @ViewChild('pdfViewer', { read: ElementRef, static: false }) pdfViewer: ElementRef<HTMLDivElement>;
  constructor() {}

  ngOnInit(): void {
    if (this.dataUrl) this.displayPdf(this.dataUrl);
  }

  async displayPdf(pdfDataUrl: string) {
    pdfjs.GlobalWorkerOptions.workerSrc = PDF_WORKER_SRC;

    // isEvalSupported false: pdf.js 3.x compiles font code with eval (CVE-2024-4367, script run by a crafted PDF)
    const loadingTask = pdfjs.getDocument({ url: pdfDataUrl, isEvalSupported: false });
    const pdf = await loadingTask.promise;

    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);

      const scale = window.devicePixelRatio + 1.5 || 2.5;
      const viewport = page.getViewport({ scale });

      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      canvas.width = viewport.width;
      canvas.style.width = '100%';
      canvas.height = viewport.height;

      await page.render({
        canvasContext: context!,
        viewport,
      }).promise;

      this.pdfViewer.nativeElement.appendChild(canvas);
    }
  }
}
